// src/index.js
import { Amplify } from 'aws-amplify';
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

Amplify.configure({
  Auth: {
    identityPoolId: 'us-east-1:2db54dcf-f402-4714-89b0-280d192f2366', // Add your Identity Pool ID here if applicable, e.g., 'us-east-1:xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx'
    region: 'us-east-1',
    userPoolWebClientId: '58i9mj0quplnuhmsro39hnnq3b',
    mandatorySignIn: true,

    Cognito: {
      userPoolId: 'us-east-1_FXIf56MNW',
      userPoolClientId: '58i9mj0quplnuhmsro39hnnq3b',
      identityPoolId: 'us-east-1:2db54dcf-f402-4714-89b0-280d192f2366', // Same as above, add if applicable
      signUpVerificationMethod: 'code',
      loginWith: {
        oauth: {
          domain: 'casalytix.auth.us-east-1.amazoncognito.com',
          scopes: ['phone', 'email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
          redirectSignIn: ['http://localhost:3000/dashboard', 'https://casalytix.com/dashboard'],
          redirectSignOut: ['http://localhost:3000/login', 'https://casalytix.com/login'],
          responseType: 'code'
        }
      },
    },
  },
});

const root = createRoot(document.getElementById('root'));
root.render(<App />);

